<template>
  <div class="min-h-screen bg-gray-50">
    <sidebar />
    <div class="relative md:ml-64">
      <div class="px-4 md:px-10 mx-auto w-full py-6">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
export default {
  name: "admin-layout",
  components: {
    Sidebar,
  },
};
</script>
